
import { Facebook, Instagram, X } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const socialLinks = [
  {
    name: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61572375376059",
    icon: Facebook,
    tooltip: "Suivez-nous sur Facebook",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/nlocalfr/",
    icon: Instagram,
    tooltip: "Suivez-nous sur Instagram",
  },
  {
    name: "X (Twitter)",
    url: "https://x.com/NLocaleFr",
    icon: X,
    tooltip: "Suivez-nous sur X",
  },
];

interface SocialIconsProps {
  className?: string;
  iconClassName?: string;
}

export const SocialIcons = ({ className = "", iconClassName = "w-5 h-5" }: SocialIconsProps) => {
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <TooltipProvider>
        {socialLinks.map((social) => (
          <Tooltip key={social.name}>
            <TooltipTrigger asChild>
              <a
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-gray-900 transition-colors"
              >
                <social.icon className={iconClassName} />
              </a>
            </TooltipTrigger>
            <TooltipContent>
              <p>{social.tooltip}</p>
            </TooltipContent>
          </Tooltip>
        ))}
      </TooltipProvider>
    </div>
  );
};
